module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112921-Telluride-Modern.64b05f91.jpeg";